import React from 'react';
import { ArrowLeft, FileText, Building2, Users, AlertTriangle, Briefcase, CreditCard, Shield, Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const Precontrattuale = () => {
  const navigate = useNavigate();

  const imprese = [
    { nome: "ASSIMOCO S.P.A.", tipo: "Mandato diretto" },
    { nome: "ASSIMOCO VITA S.P.A.", tipo: "Mandato diretto" },
    { nome: "GROUPAMA ASSICURAZIONI S.P.A.", tipo: "Mandato diretto" },
    { nome: "SLP - TUTELA LEGALE", tipo: "Mandato diretto" },
    { nome: "+SIMPLE", tipo: "Collaborazione (ex art. 22 comma 10 D.L. 179/2012)" },
    { nome: "ASSIMEDICI", tipo: "Collaborazione (ex art. 22 comma 10 D.L. 179/2012)" },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          {/* Header */}
          <div className="text-center mb-8 pb-6 border-b border-gray-200">
            <span className="inline-block px-4 py-2 bg-[#1B2380]/10 text-[#1B2380] rounded-full text-sm font-semibold mb-4">
              ALLEGATO 3
            </span>
            <h1 className="text-2xl sm:text-3xl font-bold text-[#1B2380] mb-4">
              MODULO UNICO PRECONTRATTUALE (MUP)
            </h1>
            <p className="text-gray-600">
              Per i prodotti assicurativi non d'investimento
            </p>
          </div>

          {/* Avviso */}
          <div className="bg-[#8FE3DA]/10 border border-[#8FE3DA]/30 rounded-lg p-4 mb-8">
            <p className="text-gray-700 text-sm leading-relaxed">
              Il distributore ha l'obbligo di consegnare/trasmettere al contraente il presente Modulo, 
              prima della sottoscrizione della proposta o del contratto di assicurazione. Il documento 
              può essere fornito con modalità non cartacea se appropriato rispetto alle modalità di 
              distribuzione e se il contraente lo consente (art. 120-quater del CAP).
            </p>
          </div>

          {/* Sezione I */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#1B2380] rounded-lg flex items-center justify-center text-white font-bold">
                I
              </div>
              <h2 className="text-xl font-bold text-[#1B2380]">Informazioni generali sul distributore</h2>
            </div>
            
            <p className="text-gray-700 mb-4 text-sm">
              Gli estremi identificativi e di iscrizione possono essere verificati sul sito dell'IVASS,
              nel Registro Unico degli Intermediari (RUI), all'indirizzo{' '}
              <a href="https://servizi.ivass.it/RuirPubblica/" target="_blank" rel="noopener noreferrer" className="text-[#1B2380] underline">servizi.ivass.it/RuirPubblica</a>.
            </p>

            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <h3 className="font-semibold text-gray-800 mb-2">Soggetto che entra in contatto con il contraente:</h3>
              <p className="text-gray-600 text-sm italic">Cognome e nome: ________________________________________</p>
              <p className="text-gray-500 text-xs mt-1">(Da compilare a cura dell'addetto/intermediario al momento del contatto)</p>
              <p className="text-gray-600 text-sm mt-2">Qualifica di esercizio: Addetto all'attività di distribuzione operante nei locali / Intermediario</p>
            </div>

            <div className="bg-[#1B2380]/5 rounded-lg p-6 border border-[#1B2380]/10">
              <h3 className="font-bold text-[#1B2380] mb-4">Dati della Società (Intermediario iscritto al RUI):</h3>
              <div className="space-y-3 text-sm">
                <p><strong>Denominazione sociale:</strong> Assietica Società Cooperativa Società Benefit</p>
                <p><strong>P.IVA / C.F.:</strong> 01435480916</p>
                <p><strong>Numero di Iscrizione RUI IVASS:</strong> A000480096 — Sezione A (Agenti) — Data di iscrizione: 07/02/2014 — Operativo dal 25/11/2014</p>
                <p><strong>Responsabili dell'attività di intermediazione:</strong></p>
                <ul className="list-disc list-inside ml-2 space-y-1">
                  <li>Mauro Antonio Mura (RUI: A000109886 — Sezione A, dal 02/02/2024)</li>
                  <li>Umberto Cossu (RUI: A000123471 — Sezione A, dal 07/02/2014)</li>
                </ul>
                <p><strong>Sede Legale e Operativa:</strong> Viale Antonio Gramsci, 8/G - 08015 Macomer (NU)</p>
                <p><strong>Tel.:</strong> 0785 747193 | <strong>Cell:</strong> 373 7288673</p>
                <p><strong>E-mail:</strong> <a href="mailto:agenzia@assietica.it" className="text-[#1B2380] underline">agenzia@assietica.it</a></p>
                <p><strong>PEC:</strong> <a href="mailto:cdsp@pec.confcooperative.it" className="text-[#1B2380] underline">cdsp@pec.confcooperative.it</a></p>
                <p><strong>Sito internet:</strong> <a href="https://www.assietica.it" target="_blank" rel="noopener noreferrer" className="text-[#1B2380] underline">www.assietica.it</a></p>
              </div>
            </div>
          </section>

          {/* Sezione II */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#0E8C84] rounded-lg flex items-center justify-center text-white font-bold">
                II
              </div>
              <h2 className="text-xl font-bold text-[#0E8C84]">Informazioni sul modello di distribuzione</h2>
            </div>
            
            <p className="text-gray-700 leading-relaxed">
              L'attività di distribuzione del contratto viene svolta in nome e per conto delle Imprese di 
              Assicurazione elencate nella Sezione IV, ovvero in collaborazione con altri intermediari 
              (Collaborazioni Orizzontali).
            </p>
          </section>

          {/* Sezione III */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#E67E22] rounded-lg flex items-center justify-center text-white font-bold">
                III
              </div>
              <h2 className="text-xl font-bold text-[#E67E22]">Informazioni relative a situazioni di potenziale conflitto d'interesse</h2>
            </div>
            
            <div className="bg-[#E67E22]/5 rounded-lg p-4 border-l-4 border-[#E67E22]">
              <p className="text-gray-700 leading-relaxed text-sm">
                Assietica Società Cooperativa Società Benefit <strong>non detiene</strong> una partecipazione 
                diretta o indiretta pari o superiore al 10% del capitale sociale o dei diritti di voto di 
                alcuna impresa di assicurazione. <strong>Nessuna impresa di assicurazione</strong> detiene una 
                partecipazione pari o superiore al 10% del capitale sociale o dei diritti di voto di Assietica 
                Società Cooperativa Società Benefit.
              </p>
            </div>
          </section>

          {/* Sezione IV */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#0E8C84] rounded-lg flex items-center justify-center text-white font-bold">
                IV
              </div>
              <h2 className="text-xl font-bold text-[#0E8C84]">Informazioni sull'attività di distribuzione e consulenza</h2>
            </div>
            
            <p className="text-gray-700 mb-4 leading-relaxed">
              La Società distribuisce contratti in assenza di obblighi contrattuali che le impongono di 
              offrire esclusivamente i contratti di una o più imprese di assicurazione. La Società non 
              fornisce una consulenza fondata su un'analisi imparziale e personale, salvo diversamente 
              indicato in fase precontrattuale.
            </p>

            <h3 className="font-semibold text-gray-800 mb-3">Rapporti d'affari intrattenuti con le Imprese di Assicurazione:</h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-sm">
                <thead>
                  <tr className="bg-[#0E8C84]/10">
                    <th className="border border-gray-200 px-4 py-3 text-left font-semibold text-[#0E8C84]">Impresa di Assicurazione</th>
                    <th className="border border-gray-200 px-4 py-3 text-left font-semibold text-[#0E8C84]">Tipologia di rapporto</th>
                  </tr>
                </thead>
                <tbody>
                  {imprese.map((impresa, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="border border-gray-200 px-4 py-3 font-medium">{impresa.nome}</td>
                      <td className="border border-gray-200 px-4 py-3 text-gray-600">{impresa.tipo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          {/* Sezione V */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#9B59B6] rounded-lg flex items-center justify-center text-white font-bold">
                V
              </div>
              <h2 className="text-xl font-bold text-[#9B59B6]">Informazioni sulle remunerazioni</h2>
            </div>
            
            <div className="space-y-3">
              <div className="bg-[#9B59B6]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#9B59B6] mb-2">Provvigioni</h3>
                <p className="text-gray-700 text-sm">
                  Per il contratto proposto, l'intermediario percepisce una commissione inclusa nel premio 
                  assicurativo pagato dal cliente.
                </p>
              </div>
              <div className="bg-[#9B59B6]/5 rounded-lg p-4">
                <h3 className="font-semibold text-[#9B59B6] mb-2">Collaborazioni</h3>
                <p className="text-gray-700 text-sm">
                  Nel caso di collaborazioni orizzontali, l'informativa sulle remunerazioni è complessivamente 
                  relativa ai compensi percepiti da tutti gli intermediari coinvolti nella distribuzione.
                </p>
              </div>
            </div>
          </section>

          {/* Sezione VI */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#1B2380] rounded-lg flex items-center justify-center text-white font-bold">
                VI
              </div>
              <h2 className="text-xl font-bold text-[#1B2380]">Informazioni sul pagamento dei premi</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              I premi pagati all'intermediario costituiscono <strong>patrimonio autonomo e separato</strong>.
            </p>

            <h3 className="font-semibold text-gray-800 mb-3">Modalità di pagamento ammesse:</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 bg-gray-50 rounded-lg p-4">
                <CreditCard className="text-[#1B2380] flex-shrink-0 mt-1" size={20} />
                <div>
                  <h4 className="font-semibold text-gray-800">Bonifico Bancario</h4>
                  <p className="text-gray-600 text-sm">Su conto corrente separato intestato a Assietica Società Cooperativa Società Benefit.</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 bg-gray-50 rounded-lg p-4">
                <FileText className="text-[#1B2380] flex-shrink-0 mt-1" size={20} />
                <div>
                  <h4 className="font-semibold text-gray-800">Assegni</h4>
                  <p className="text-gray-600 text-sm">Bancari, postali o circolari non trasferibili intestati all'Impresa di Assicurazione o all'intermediario (espressamente in tale qualità).</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 bg-gray-50 rounded-lg p-4">
                <Building2 className="text-[#1B2380] flex-shrink-0 mt-1" size={20} />
                <div>
                  <h4 className="font-semibold text-gray-800">Contante</h4>
                  <p className="text-gray-600 text-sm">Nei limiti di legge (€ 750,00 annui per contratto) esclusivamente per i rami previsti dalla normativa.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Sezione VII */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#E74C3C] rounded-lg flex items-center justify-center text-white font-bold">
                VII
              </div>
              <h2 className="text-xl font-bold text-[#E74C3C]">Informazioni sugli strumenti di tutela</h2>
            </div>
            
            <p className="text-gray-700 mb-4">
              L'attività è garantita da una <strong>polizza di Responsabilità Civile Professionale</strong> per 
              negligenze ed errori.
            </p>

            <div className="bg-[#E74C3C]/5 rounded-lg p-6 border border-[#E74C3C]/10">
              <h3 className="font-bold text-[#E74C3C] mb-3">Reclami</h3>
              <p className="text-gray-700 mb-4 text-sm">Il contraente ha facoltà di inoltrare reclamo per iscritto a:</p>
              <div className="space-y-2 text-sm mb-4">
                <p><strong>E-mail:</strong> <a href="mailto:agenzia@assietica.it" className="text-[#1B2380] underline">agenzia@assietica.it</a></p>
                <p><strong>PEC:</strong> <a href="mailto:cdsp@pec.confcooperative.it" className="text-[#1B2380] underline">cdsp@pec.confcooperative.it</a></p>
                <p><strong>Indirizzo:</strong> Viale Antonio Gramsci, 8/G - 08015 Macomer (NU)</p>
                <p><strong>Tel.:</strong> 0785 747193 | <strong>Cell:</strong> 373 7288673</p>
              </div>
              <p className="text-gray-700 text-sm">
                Qualora non soddisfatto dall'esito, l'interessato può rivolgersi all'<strong>IVASS</strong> o 
                avvalersi di sistemi di risoluzione stragiudiziale come l'Arbitro Assicurativo 
                (<a href="https://www.arbitroassicurativo.org" target="_blank" rel="noopener noreferrer" className="text-[#1B2380] underline">www.arbitroassicurativo.org</a>).
              </p>
            </div>
          </section>

          {/* Sezione VIII */}
          <section className="mb-8">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#E91E63] rounded-lg flex items-center justify-center text-white font-bold">
                VIII
              </div>
              <h2 className="text-xl font-bold text-[#E91E63]">Diritto all'oblio oncologico</h2>
            </div>
            
            <div className="bg-[#E91E63]/5 rounded-lg p-4 border-l-4 border-[#E91E63]">
              <div className="flex items-start space-x-3">
                <Heart className="text-[#E91E63] flex-shrink-0 mt-1" size={20} />
                <p className="text-gray-700 leading-relaxed">
                  L'intermediario informa che il contraente può esercitare il <strong>diritto all'oblio oncologico</strong> previsto 
                  dalla Legge n. 193/2023. I dettagli operativi sono riportati nel DIP Aggiuntivo specifico del prodotto.
                </p>
              </div>
            </div>
          </section>

          {/* Sezione IX - Documentazione scaricabile */}
          <section className="mb-8" data-testid="documenti-scaricabili-section">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#0E8C84] rounded-lg flex items-center justify-center text-white font-bold">
                IX
              </div>
              <h2 className="text-xl font-bold text-[#0E8C84]">Documentazione precontrattuale scaricabile</h2>
            </div>

            <p className="text-gray-700 text-sm mb-4 leading-relaxed">
              In conformità ai Regolamenti IVASS, il consumatore ha diritto di consultare liberamente la
              documentazione precontrattuale prima di essere vincolato da qualsiasi contratto. I documenti
              sotto elencati sono scaricabili gratuitamente; i Set Informativi (DIP e DIP Aggiuntivo)
              specifici di ciascun prodotto vengono sempre consegnati prima della sottoscrizione e sono
              disponibili sul sito dell'impresa di assicurazione.
            </p>

            <div className="space-y-3">
              {[
                { nome: 'Allegato 3 — Informativa sul distributore (MUP)', file: `${process.env.REACT_APP_BACKEND_URL}/api/docs/allegato-3`, testid: 'download-allegato-3' },
                { nome: 'Allegato 4 — Informazioni sulla distribuzione del prodotto', file: `${process.env.REACT_APP_BACKEND_URL}/api/docs/allegato-4`, testid: 'download-allegato-4' },
                { nome: 'Allegato 4-ter — Elenco obblighi di comportamento', file: `${process.env.REACT_APP_BACKEND_URL}/api/docs/allegato-4ter`, testid: 'download-allegato-4ter' },
              ].map((doc) => (
                <a
                  key={doc.file}
                  href={doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={doc.testid}
                  className="flex items-center justify-between bg-[#0E8C84]/5 border border-[#0E8C84]/20 rounded-lg px-4 py-3 hover:bg-[#0E8C84]/10 transition-colors duration-300"
                >
                  <span className="text-gray-800 text-sm font-medium">{doc.nome}</span>
                  <span className="text-[#0E8C84] text-sm font-semibold flex-shrink-0 ml-3">Scarica PDF ↓</span>
                </a>
              ))}
            </div>

            <p className="text-gray-500 text-xs mt-4">
              Copia cartacea della documentazione è sempre disponibile gratuitamente presso le nostre sedi
              e può essere richiesta a <a href="mailto:agenzia@assietica.it" className="text-[#1B2380] underline">agenzia@assietica.it</a>.
            </p>
          </section>

          {/* Back button */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Torna alla Home
            </button>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#10154F] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Precontrattuale;
